const ServiceBaseUrl = 'https://api.breadcrumbs.me'
const ServiceSearchUrl = 'https://search.api.breadcrumbs.me'
const ServiceRecognitionUrl = 'https://storage.breadcrumbs.me'

const StoreAndroidAppUrl = 'https://play.google.com/store/apps/details?id=com.foodtwosteps.FoodTwoSteps'
const StoreIOSAppUrl = 'https://apps.apple.com/us/app/foodtwosteps/id6733241671'

const OAuthAuthUrl = 'https://auth.entrum.ru'
const OAuthClientId = 'foodhunt-admin'

export {
	StoreAndroidAppUrl,
	StoreIOSAppUrl,
	ServiceBaseUrl,
	ServiceSearchUrl,
	ServiceRecognitionUrl,
	OAuthAuthUrl,
	OAuthClientId,
}
